export const constant = {
	selector: {
		target: 'js-m-input',
	},
	modifier: {
		autoHeight: 'js-m-input-auto-height',
		maxHeight: 'mInputMaxHeight',
	},
}
